import { render } from "./App.vue?vue&type=template&id=8ed3bec0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8ed3bec0&lang=scss"

import exportComponent from "/Users/benjaminjehl/projects/letterdropz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__